import { CombatStatus, NpcDifficulty } from '@game/enums';
import type {
  ClientCombatantIdentifier,
  ClientCombatantStatic,
  ClientCombatReward,
  ClientCombatRound,
  ClientCombatTurn,
  CombatRolls,
} from '@game/shared-types';

import type { CombatRoundCombatantsStats, CombatTurnData } from '../types/combat.types';

export const defaultTarget: ClientCombatantStatic = {
  type: 'npc',
  id: '',
  image: '',
  name: '',
  armour: 0,
  damageMin: 0,
  damageMax: 0,
  level: 0,
  team: 0,
  skills: [],
  difficulty: NpcDifficulty.Normal,
  species: 'Human',
};

const defaultTurn: ClientCombatTurn = {
  sequenceKey: '',
  nextSequenceKey: '',
  actor: {} as ClientCombatantIdentifier,
  actions: [
    {
      type: 0,
      skillName: 'Skip',
      rolls: {} as CombatRolls,
      target: defaultTarget,
      equipment: undefined,
      killingBlow: false,
      actor: {} as ClientCombatantIdentifier,
    },
  ],
};

const defaultTurnData: CombatTurnData = {
  roundNumber: 0,
  turnNumber: 0,
  turn: defaultTurn,
};

export const defaultCombatReward = {
  experience: 0,
  items: [],
};

const defaultCombatRound: ClientCombatRound = {
  roundNumber: 0,
  turnOrder: [],
  turns: [],
  combatantsStats: [],
  turnExpireAt: -1,
};

export interface CombatState {
  combatLatestTurn: CombatTurnData;
  combatRoundCombatantsStats: CombatRoundCombatantsStats[];
  combatStatus: CombatStatus;
  combatReward: ClientCombatReward;
  target: ClientCombatantStatic;
  combatLogHistory: CombatTurnData[];
  turnQueue: CombatTurnData[];
  nextSequenceKey: string;
  currentRound: ClientCombatRound;
  previousRound: ClientCombatRound;
  combatants: ClientCombatantStatic[];
  combatLocationName: string;
}

export const combatDefault: CombatState = {
  combatLatestTurn: defaultTurnData,
  combatRoundCombatantsStats: [],
  combatStatus: CombatStatus.Unknown,
  combatReward: defaultCombatReward,
  target: defaultTarget,
  combatLogHistory: [],
  turnQueue: [],
  nextSequenceKey: '',
  currentRound: defaultCombatRound,
  previousRound: defaultCombatRound,
  combatants: [],
  combatLocationName: '',
};
